import api from "./api";
import { TConversation, TConversationStatus } from "../models/conversation";
import { GetServerSidePropsContext } from "next";

export type TConversationListFilter = {
  status: TConversationStatus;
};

export type TLoadConversationsPayload = Partial<{
  cursor: number;
  filters: TConversationListFilter | null;
  sort: string;
}>;

export default function loadConversations(
  appId: string,
  context?: GetServerSidePropsContext,
  account?: boolean,
  payload?: TLoadConversationsPayload
) {
  return api<{ data: TConversation[]; total: number }>({
    method: "POST",
    path: `/customer-portal/${account ? "account/" : "customer/"}conversations`,
    body: { ...payload },
    appId,
    context,
  });
}
